export * from './full-layout.component';



// WEBPACK FOOTER //
// ./src/app/containers/full-layout/index.ts